import {
  CopyToClipboardButton,
  MessageBar,
  MessageBarType,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { TenantDeploymentRingGetArgs } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useTenantDeploymentRings } from "@libs/api/gateways/field/field-ops-gateway.hooks";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Permissions } from "@libs/permissions/permissions.enum";

import { ClientDeploymentRings } from "./ClientDeploymentRings";
import { ServerDeploymentRingsTable } from "./ServerDeploymentRings";

interface DeploymentRingsTenantPageProps {
  tenant: Tenant;
}

const DeploymentRingsTenant = ({ tenant }: DeploymentRingsTenantPageProps) => {
  const { id: tenantId } = tenant;
  const theme = useTheme();

  const {
    data: TenantDeploymentRings,
    isLoading,
    error
  } = useTenantDeploymentRings({
    tenantId
  } as TenantDeploymentRingGetArgs);

  return (
    <Stack
      key={tenantId}
      styles={{
        root: {
          paddingLeft: 10,
          paddingRight: 10
        }
      }}
      tokens={{ childrenGap: theme.spacing.s1 }}
    >
      <SectionTitle>Tenant Deployment Rings</SectionTitle>
      <Stack horizontal styles={{ root: { alignItems: "center" } }}>
        <Text bold>TenantId: </Text>
        <CopyToClipboardButton clipboardContent={tenant.id} text={tenant.id} />
      </Stack>
      <MessageBar messageBarType={MessageBarType.info}>
        A higher order deployment ring takes precedence over rings which are
        below it.
      </MessageBar>
      <Stack tokens={{ childrenGap: theme.spacing.l1 }}>
        <ServerDeploymentRingsTable
          items={TenantDeploymentRings ?? []}
          enableShimmer={isLoading}
          errorMessage={error?.message}
          tenant={tenant}
        />
        <ClientDeploymentRings
          items={TenantDeploymentRings ?? []}
          enableShimmer={isLoading}
          errorMessage={error?.message}
          tenant={tenant}
        />
      </Stack>
    </Stack>
  );
};

export const DeploymentRingsTenantPage = withPermissions(
  DeploymentRingsTenant,
  [
    Permissions.PltFieldManagementRead,
    Permissions.PltFieldManagementWrite,
    Permissions.PltFieldManagementDeploy
  ],
  "or"
);
